import { PolygraphyProductFormat } from '../../../../../services/exports/Constants';

export default {
  form: {
    name: {
      label: 'Nombre del trabajo de impresión',
      placeholder: 'Flyer A5 - promoción especial',
    },
    format: {
      label: 'Tipo de producto',
      placeholder: 'Seleccionar tipo de producto',
      options: {
        [PolygraphyProductFormat.FlyerA5]: 'Flyer (A5)',
        [PolygraphyProductFormat.FlyerA6]: 'Flyer (A6)',
        [PolygraphyProductFormat.Sticker60x60]: 'Pegatina (60x60mm)',
        [PolygraphyProductFormat.DoorStickerA5]: 'Pegatina de puerta (30x30cm)',
      },
    },
    file: {
      label: 'Archivo',
    },
  },
  buttons: {
    upload: 'Haz clic o arrastra para subir el archivo',
    save: 'Guardar',
  },
  toasts: {
    changes_got_saved: '¡Cambios guardados!',
  },
};
